import { CREATE_NOTIFICATION, GET_NOTIFICATION, GET_NOTIFICATIONS, SAVE_NOTIFICATION_AS_DRAFT, SET_ALL_NOTIFICATIONS, SET_ALL_NOTIFICATIONS_SELECT, UPDATE_NOTIFICATION } from "../../reducerTypes";



const initialState = {
    getData: {},
    getList: [],
    selectData: [],
  };


  const notificationReducer = (state = initialState, action ) =>{

    switch (action.type) {
       
        case SET_ALL_NOTIFICATIONS:
          
          return {
            ...state,
            getList: action.payload,
          };
        case GET_NOTIFICATIONS:
          return {
            ...state,
            getList: action.payload,
          };
        case SET_ALL_NOTIFICATIONS_SELECT:
          const contentData = action.payload ? action.payload : [];
          const selectData = [];
          contentData.map((data) => {
            selectData.push({
              value: data.id,
              label: `${data.title}`,
            });
          });
          return {
            ...state,
            selectData: selectData,
          };
        case CREATE_NOTIFICATION:
          return {
            ...state,
            getData: action.payload,
          };
         case SAVE_NOTIFICATION_AS_DRAFT:
            return {
              ...state,
              getData: action.payload,
            };
        case GET_NOTIFICATION:
          return {
            ...state,
            getData: action.payload,
          };
        case UPDATE_NOTIFICATION:
          return {
            ...state,
            getData: action.payload,
          };
        default:
          return state;
      }
  }


  export default notificationReducer